import { sm2 } from 'sm-crypto'

export default function useSm2() {
  return React.useMemo(() => ({
    encode: data => `04${sm2.doEncrypt(data, '046f6c922880f70e5e1767112b36ea38cfe5eabe65d4fa4f369b66ee53ed98ca610fb55bf8b294ec69c6cb20a7580c860c3e95348024631d76e403611b6fae9bb7', 0)}`
  }), [])
}
